import { useCallback } from 'react';

import { useOnPlayingStateChanged } from '@/scenarios/legacy-player/hooks/useOnPlayingStateChanged';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

import { useNextEpisode } from '../../../../../episode-player/hooks/use-next-episode';

export const useOnEpisodeEnd = (contentId: string, onClose?: () => void) => {
    const hasNextEpisode = Boolean(useNextEpisode(contentId));

    const onPlayingStateChanged = useCallback(
        (playingState: PlayingState | undefined) => {
            if (playingState === PlayingState.end && !hasNextEpisode) {
                onClose?.();
            }
        },
        [onClose, hasNextEpisode]
    );

    useOnPlayingStateChanged(onPlayingStateChanged);
};
